import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {TradeRoutingModule} from './trade-routing.module';
import {MainComponent} from './components/main/main.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import { CurrencyDirective } from './directives/currency.directive';


@NgModule({
  declarations: [
    MainComponent,
    CurrencyDirective
  ],
  imports: [
    CommonModule,
    TradeRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ]
})
export class TradeModule {
}
